import { render, staticRenderFns } from "./ManagerShiftsRegistry.vue?vue&type=template&id=6f9643cc&lang=pug&"
import script from "./ManagerShiftsRegistry.vue?vue&type=script&lang=js&"
export * from "./ManagerShiftsRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports